import React, { Component } from 'react';
import classes from './SearchResultHeader.scss';

import { Events } from 'react-scroll';

class SearchResultHeader extends Component {

    state = {
        isScroll: false
      }
    
      componentDidMount() {
        Events.scrollEvent.register('begin');
        Events.scrollEvent.register('end');
      }
    
      componentWillUnmount() {
        Events.scrollEvent.remove('begin');
        Events.scrollEvent.remove('end');
      }

    render() {
        window.onscroll = () => {
            if(window.pageYOffset > 0) {
              this.setState({
                isScroll: true
              });
            } else {
              this.setState({
                isScroll: false
              });
            }
        }

        return (
            <div style={{boxShadow: this.state.isScroll ? (window.innerWidth < 600 ? '0 2px 1.4rem rgba(0, 0, 0, .20)' : '0 2px 4px rgba(0, 0, 0, 0.06)') : 'none'}} className={classes.Header}>
                {this.props.children}
            </div>
        );
    }
}

export default SearchResultHeader;


// WEBPACK FOOTER //
// ./src/components/UI/Headers/SearchResultHeader/SearchResultHeader.js